
<div class="scroll-wrapper" :class="{ sand: background === 'sand' }">
  <div class="top" :class="{ 'hidden-block': !showTopFade }"></div>
  <div class="scroll" :class="{ 'hidden-scrollbar': hideScrollbar }" @scroll="checkScroll" ref="scrollContent">
    <slot />
  </div>
  <div class="bottom" :class="{ 'hidden-block': !showBottomFade }"></div>
</div>
